// libraries
import { useState, useEffect, useContext, useRef } from "react";
import { useParams } from "react-router-dom";
import firebase from "../firebase/firebase";
import { useToasts } from "react-toast-notifications";
import { useReactToPrint } from "react-to-print";

// context
import RecipesContext from "../context/recipes";

// context
import UserContext from "../context/user";

// style
import "../styles/MealPlan.css";

// components
import Hero from "../components/Hero";
import MealPlanItem from "../components/MealPlan/MealPlanItem";
import MealPlanDrawer from "../components/MealPlan/MealPlanDrawer";

// assests
import Loading from "../assets/hour_glass.gif";

const FirstWeek = {
  breakfast: [],
  lunch: [],
  dinner: [],
};

const SecondWeek = {
  breakfast: [],
  lunch: [],
  dinner: [],
};
let flag = false;
const MealPlan = () => {
  // use context
  const { recipes } = useContext(RecipesContext);
  const { user } = useContext(UserContext);
  const { addToast } = useToasts();

  // state
  const [breakfastRecipes, setBreakFastRecipes] = useState([]);
  const [lunchRecipes, setLunchRecipes] = useState([]);
  const [dinnerRecipes, setDinnerRecipes] = useState([]);
  const [showDrawer, setShowDrawer] = useState(false);
  const [drawerRecipes, setDrawerRecipes] = useState({});
  const [tabIndex, setTabIndex] = useState(1);
  const [loading, setLoading] = useState(true);
  const [oneTimeClick, setOneTimeClick] = useState(false);
  const [alertMsg, setAlertMsg] = useState("Generating Meal Plan For You");

  // reference
  const componentRef = useRef();

  // route params
  const { week } = useParams();

  useEffect(() => {
    if (!flag) {
      if (user !== null) {
        flag = true;
        fetchRecipesFromFB();
      } else {
        showLoading(1);
      }
    }
  }, [recipes]);

  const fetchRecipesFromFB = () => {
    firebase
      .firestore()
      .collection("users")
      .doc(user.uid)
      .get()
      .then((doc) => {
        if (doc.exists) {
          let data = doc.data();
          if (data?.weekOne?.breakfast?.length > 0) {
            setLoading(false);
            FirstWeek.breakfast = data.weekOne.breakfast;
            FirstWeek.lunch = data.weekOne.lunch;
            FirstWeek.dinner = data.weekOne.dinner;

            SecondWeek.breakfast = data.weekTwo.breakfast ?? [];
            SecondWeek.lunch = data.weekTwo.lunch ?? [];
            SecondWeek.dinner = data.weekTwo.dinner ?? [];

            setBreakFastRecipes(FirstWeek.breakfast);
            setLunchRecipes(FirstWeek.lunch);
            setDinnerRecipes(FirstWeek.dinner);
            console.log("document", data);
          } else {
            console.log("recipes from context", recipes);
            showLoading(1);
          }
        }
      });
  };

  const showLoading = (week) => {
    setTimeout(() => {
      setLoading(false);
      generateMealPlan(week);
    }, 3000);
  };

  // filter recipes
  const filterRecipes = (meal) => {
    return recipes.filter((recipe) => recipe.meal === meal);
  };

  const shuffleArray = (arr) => {
    for (let i = arr.length - 1; i > 0; i--) {
      let j = Math.floor(Math.random() * (i + 1));
      let temp = arr[i];
      arr[i] = arr[j];
      arr[j] = temp;
    }

    if (arr.length > 7) {
      arr = arr.slice(0, 7);
    }

    return arr;
  };

  const generateMealPlan = (week) => {
    if (week === 1) {
      FirstWeek.breakfast = shuffleArray(filterRecipes("breakfast"));
      FirstWeek.lunch = shuffleArray(filterRecipes("lunch"));
      FirstWeek.dinner = shuffleArray(filterRecipes("dinner"));

      setBreakFastRecipes(FirstWeek.breakfast);
      setLunchRecipes(FirstWeek.lunch);
      setDinnerRecipes(FirstWeek.dinner);
    } else if (week === 2) {
      SecondWeek.breakfast = shuffleArray(filterRecipes("breakfast"));
      SecondWeek.lunch = shuffleArray(filterRecipes("lunch"));
      SecondWeek.dinner = shuffleArray(filterRecipes("dinner"));

      setBreakFastRecipes(SecondWeek.breakfast);
      setLunchRecipes(SecondWeek.lunch);
      setDinnerRecipes(SecondWeek.dinner);
    }
  };

  const setDrawerRecipesList = (meal, uuid, index, catg) => {
    let drawerContent = {};
    drawerContent.recipes = recipes;
    drawerContent.type = meal;
    drawerContent.uuid = uuid;
    drawerContent.index = index;
    drawerContent.category = catg;

    setDrawerRecipes(drawerContent);
  };

  const getDrawerRecipe = (data) => {
    if (drawerRecipes.type === "breakfast") {
      if (tabIndex === 1) {
        FirstWeek.breakfast = breakfastRecipes.map((item, i) =>
          drawerRecipes.uuid === item.uuid ? data : item
        );
        setBreakFastRecipes(FirstWeek.breakfast);
      } else if (tabIndex === 2) {
        SecondWeek.breakfast = breakfastRecipes.map((item, i) =>
          drawerRecipes.uuid === item.uuid ? data : item
        );
        setBreakFastRecipes(SecondWeek.breakfast);
      }
    } else if (drawerRecipes.type === "lunch") {
      if (tabIndex === 1) {
        FirstWeek.lunch = lunchRecipes.map((item, i) =>
          drawerRecipes.uuid === item.uuid ? data : item
        );
        setLunchRecipes(FirstWeek.lunch);
      } else if (tabIndex === 2) {
        SecondWeek.lunch = lunchRecipes.map((item, i) =>
          drawerRecipes.uuid === item.uuid ? data : item
        );
        setLunchRecipes(SecondWeek.lunch);
      }
    } else if (drawerRecipes.type === "dinner") {
      if (tabIndex === 1) {
        FirstWeek.dinner = dinnerRecipes.map((item, i) =>
          drawerRecipes.uuid === item.uuid ? data : item
        );
        setDinnerRecipes(FirstWeek.dinner);
      } else if (tabIndex === 2) {
        SecondWeek.dinner = dinnerRecipes.map((item, i) =>
          drawerRecipes.uuid === item.uuid ? data : item
        );
        setDinnerRecipes(SecondWeek.dinner);
      }
    }
    setShowDrawer(false);
  };

  const uploadMealPlanToFS = () => {
    if (user !== null) {
      setLoading(true);
      firebase
        .firestore()
        .collection("users")
        .doc(user.uid)
        .set(
          {
            weekOne: {
              breakfast: FirstWeek.breakfast,
              lunch: FirstWeek.lunch,
              dinner: FirstWeek.dinner,
            },
            weekTwo: {
              breakfast: SecondWeek.breakfast,
              lunch: SecondWeek.lunch,
              dinner: SecondWeek.dinner,
            },
          },
          { merge: true }
        )
        .then(() => {
          console.log("meal plan added");
          addToast("meal plan added", {
            appearance: "success",
          });
          setLoading(false);
          setAlertMsg("Generating Meal Plan For You");
        })
        .catch((e) => {
          setLoading(false);
          setAlertMsg("Generating Meal Plan For You");
          addToast(e.message, {
            appearance: "error",
          });
          console.log("meal plan error", e.message);
        });

      // console.log("loading.....");
      // let batch = firebase.firestore().batch();
      // mealPlanRecipes.forEach((recipe) => {
      //   let docRef = mealPlanCollection.doc(recipe.uuid);
      //   batch.set(docRef, recipe);
      // });

      // batch.commit().then(() => {
      //   console.log("all recipes pushed");
      // });
    } else {
      console.log("Please Login first");
      setAlertMsg("Generating Meal Plan For You");
      addToast("Please Login First", {
        appearance: "warning",
      });
    }
  };

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  return (
    <>
      <Hero
        // image={bg}
        title={week === "1" ? "1 Week Meal Plan" : "2 Week Meal Plan"}
        breadName="Meal Plan"
        singleProduct={false}
      />
      {loading ? (
        <div className="meal-plan-loading">
          <img src={Loading} alt="loading" />
          <h4>{alertMsg}......</h4>
        </div>
      ) : (
        <>
          {week === "2" && (
            <div className="meal-plan-tabs">
              <div
                className="tab"
                style={{
                  color: tabIndex === 1 ? "#d63230" : "#666",
                  fontWeight: tabIndex === 1 ? "600" : "400",
                }}
                onClick={() => {
                  setTabIndex(1);
                  setBreakFastRecipes(FirstWeek.breakfast);
                  setLunchRecipes(FirstWeek.lunch);
                  setDinnerRecipes(FirstWeek.dinner);
                }}
              >
                First Week Meal Plan
              </div>
              <hr />
              <div
                className="tab"
                style={{
                  color: tabIndex === 2 ? "#d63230" : "#666",
                  fontWeight: tabIndex === 2 ? "600" : "400",
                }}
                onClick={() => {
                  setTabIndex(2);
                  if (!oneTimeClick && SecondWeek.breakfast.length === 0) {
                    setLoading(true);
                    showLoading(2);
                    setOneTimeClick(true);
                  } else {
                    setBreakFastRecipes(SecondWeek.breakfast);
                    setLunchRecipes(SecondWeek.lunch);
                    setDinnerRecipes(SecondWeek.dinner);
                  }
                }}
              >
                Second Week Meal Plan
              </div>
            </div>
          )}
          <section className="meal-wrapper my-5">
            <div className="mx-3">
              <div className="mb-2">
                <button
                  className="btn btn-primary mx-1"
                  onClick={() => {
                    setAlertMsg("Saving Meal Plan");
                    uploadMealPlanToFS("weekOne");
                  }}
                >
                  Save Meal Plan
                </button>
                {/* <button
                  className="btn btn-secondary mx-1"
                  onClick={() => handlePrint()}
                >
                  Print Meal Plan
                </button> */}
              </div>
              <div className="meal-plan" ref={componentRef}>
                <div className="meal-plan-side">
                  <div className="meal-plan-item"></div>
                  <div className="meal-plan-item">BreakFast</div>
                  <div className="meal-plan-item">Lunch</div>
                  <div className="meal-plan-item">Dinner</div>
                </div>
                <div className="meal-plan-main">
                  <div className="meal-plan-main-row mb-2">
                    <div className="meal-row-heading">Sunday</div>
                    <div className="meal-row-heading">Monday</div>
                    <div className="meal-row-heading">Tuesday</div>
                    <div className="meal-row-heading">Wednesday</div>
                    <div className="meal-row-heading">Thursday</div>
                    <div className="meal-row-heading">Friday</div>
                    <div className="meal-row-heading">Saturday</div>
                  </div>
                  <div className="meal-plan-main-row">
                    {breakfastRecipes.map((recipe, i) => (
                      <div key={i} className="meal-row-item my-1">
                        <MealPlanItem
                          data={recipe}
                          setShowDrawer={setShowDrawer}
                          index={i}
                          setDrawer={setDrawerRecipesList}
                          mealPlan="breakfast"
                        />
                      </div>
                    ))}
                  </div>
                  <div className="meal-plan-main-row">
                    {lunchRecipes.map((recipe, i) => (
                      <div key={i} className="meal-row-item my-1">
                        <MealPlanItem
                          data={recipe}
                          setShowDrawer={setShowDrawer}
                          index={i}
                          setDrawer={setDrawerRecipesList}
                          mealPlan="lunch"
                        />
                      </div>
                    ))}
                  </div>
                  <div className="meal-plan-main-row mb-2">
                    {dinnerRecipes.map((recipe, i) => (
                      <div key={i} className="meal-row-item my-1">
                        <MealPlanItem
                          data={recipe}
                          setShowDrawer={setShowDrawer}
                          index={i}
                          setDrawer={setDrawerRecipesList}
                          mealPlan="dinner"
                        />
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
            {showDrawer && (
              <MealPlanDrawer
                drawerRecipes={drawerRecipes}
                setShowDrawer={setShowDrawer}
                getRecipe={getDrawerRecipe}
              />
            )}
          </section>
        </>
      )}
    </>
  );
};

export default MealPlan;
